import { Inject, Injectable } from "ng-metadata/core";
import {getDefaultScope, getVid, getTab,getCurrentPCKey} from '../appConfig/appConfigForward';
import {PrimolyticsService, beacon} from '../analytics/primolytics.service';
import {preventStateReload} from '../infra/annotations';
import { STATE_NAMES } from "../primoExplore/primoExploreStates.module";

const get = require('lodash/get');

@Injectable()
export class ResearchAssistantService{

    private _cameFrom: string = '';
    
    constructor(@Inject('I18nService') private i18nService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$stateParams') private $stateParams: angular.ui.IStateParamsService,     
                @Inject('$state') private $state: angular.ui.IStateService,
                private primolyticsService: PrimolyticsService) {
    }

    public getVid(){
        return getVid();
    }

    public getLang(){
        return this.i18nService.getLanguage();
    }

    public getPcKey(){
        return getCurrentPCKey();
    }

    get isSearchAssistant() {
      return this.$state.current.name === STATE_NAMES.AUTHORITY_SEARCH
    }
    
    set cameFrom(value: string) {
        this._cameFrom = value;
    }
    
    get cameFrom(): string {
        return this._cameFrom;
    }

    public sendRABeacon(eventActionDetails) {
        let beaconAction = beaconActions.find(beaconAction => 
            get(beaconAction,'action',[]).includes(get(eventActionDetails,'action','')) && 
            get(beaconAction,'category','') === get(eventActionDetails,'category','') &&
            (!get(beaconAction,'label','') || get(beaconAction,'label','') === get(eventActionDetails,'label',''))
        );
        let operation = get(beaconAction,'operation','');
        if (operation) {
            this.primolyticsService.doBeaconReport({
                'p': 'researchAssistant', 'op': operation
            }, eventActionDetails, this.primolyticsService.getTimestamp());
        }
    }
}

const beaconActions = [
  {
    "action": ["search","inputbox_new", "inputbox_followup", "webcomponent"],
    "category": "search",
    "operation": "search",
    // "User runs a RA Search"
  },
  {
    "action": ["regenerate"],
    "category": "answer",
    "operation": "rerunSearch",
    // "User reruns a RA Search using button rerun Search"
  },
  {
    "action": ["copy"],
    "category": "answer",
    "operation": "copyAnswer",
    // "User clicks the Copy option for RA answer"
  },
  {
    "action": ["thumbs_up"],
    "category": "feedback",
    "label": "answerId",
    "operation": "thumbsUpAnswer",
    // "User clicks the thumbs up option for RA answer"
  },
  {
    "action": ["thumbs_down"],
    "category": "feedback",
    "label": "answerId",
    "operation": "thumbsDownAnswer",
    // "User clicks the thumbs down option for RA answer"
  },
  {
    "action": ["search-library"],
    "category": "source",
    "operation": "raEnhancedPrimosearch",
    // "User invokes a Primo search using RA enhanced query"
  },
  {
    "action": ["expand-from-sourcecard"],
    "category": "source",
    "operation": "displaySource",
    // "User clicks to display source in RA answer"
  },
  {
    "action": ["pdf"],
    "category": "source",
    "operation": "quicklinkPDF",
    // "User clicks PDF Quicklink in RA source"
  },
  {
    "action": ["fulltext"],
    "category": "source",
    "operation": "quicklinkHTML",
    // "User clicks HTML Quicklink in RA source"
  },
  {
    "action": ["deeplink"],
    "category": "source",
    "operation": "openfull",
    // "User opens full record display for Source in RA answer"
  },
  {
    "action": ["more-questions"],
    "category": "search",
    "operation": "clickRelatedResearchQuestion",
    // "User clicks related research question in RA answer"
  },
  {
    "action": ["thumbs_up"],
    "category": "feedback",
    "label": "sourceId",
    "operation": "thumbsUpSource",
    // "User clicks the thumbs up option for Source in RA answer"
  },
  {
    "action": ["thumbs_down"],
    "category": "feedback",
    "label": "sourceId",
    "operation": "thumbsDownSource",
    // "User clicks the thumbs down option for Source in RA answer"
  },
  {
    "action": ["help"],
    "category": "navigation",
    "operation": "clickHelp",
    // "User clicks the Help function"
  },
  {
    "action": ["disclaimer"],
    "category": "navigation",
    "operation": "clickAIDisclaimer"
    // "User clicks the AI disclaimer"
  },
  {
    "action": ["new-session"],
    "category": "navigation",
    "operation": "newSession"
    // "User clicks the AI new session"
  }
]; 



// WEBPACK FOOTER //
// ./src/main/webapp/components/researchAssistant/researchAssistant.service.ts